import { type IEventWithData, type IEventDataProps } from '@/Events/Types'

class EventWithData implements IEventWithData {
  type: string
  data: any
  nativeEvent?: Event
  constructor (type: string, props: IEventDataProps) {
    this.type = type
    this.data = props.data
    this.nativeEvent = props.nativeEvent
  }
}

export default EventWithData
